import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Link} from 'shells/link/link';

type Props = {
    onDismiss?: () => void;
};

export function ProPlanInfo(props: Props) {
    return (
        <EmptyStateLarge
            title={'Automatically send follow-up emails'}
            subtitle={
                'With Nutshell Pro’s personal email sequences, remembering to followup has never been easier. In fact, we’ll do it for you.'
            }
            icon={
                <img
                    alt=''
                    style={{width: 260}}
                    src='/include/images/email-drip/email-scheduled_non-pro_2x.png'
                />
            }
            detailTextBullets={[
                'Configure follow-up messages in your email templates, and schedule how soon they should be sent.',
                'Automatic follow-up only happens when contacts don’t reply. Once you’ve received a reply, follow-up will stop.',
                'Customize messages every time you send them. (Or don’t! You have full control.)',
            ]}
            cta={
                // @ts-expect-error
                <Link variant='button-primary' size='big' as={RoutedLink} to='/setup/billing/sales'>
                    Learn more about Nutshell Pro
                </Link>
            }
            dismissal={
                props.onDismiss
                    ? {
                          title: 'No thanks, take me back',
                          onClick: props.onDismiss,
                      }
                    : undefined
            }
        />
    );
}
